import { BillingPackage } from "../types/BillingPackage";

interface PackageProps {
    _id: string;
    name: string;
    price: number;
    description: string;
    content: string[];
    duration: number;
    service_name: string;
    created_at: string;
    imageSrc?: string;
    onEdit?: (pkg: BillingPackage) => void;
}

export default function PackageContainer({
    _id,
    name,
    price,
    description,
    content,
    duration,
    service_name,
    created_at,
    imageSrc = '/images/package.png',
    onEdit
}: PackageProps) {
    return (
        <div className="cursor-pointer transition-colors duration-200" onClick={() => onEdit?.({
            _id,
            name,
            price,
            description,
            content,
            duration,
            service_name,
            created_at
        })}>
            <div className="w-[300px] h-[110px] flex gap-x-4 p-3 items-center justify-start bg-card rounded-lg">
                <div className="w-[80px] h-[80px] rounded-lg overflow-hidden flex-shrink-0">
                    <img
                        src={imageSrc}
                        alt={`${name} package`}
                        className="w-full h-full object-cover"
                    />
                </div>
                <div className="flex flex-col items-start justify-start flex-1">
                    <p className="text-white text-xs">{name}</p>
                    <p className="text-white text-2xl font-bold py-1">{price}</p>
                    <p className="text-gray-500 text-xs">{description}</p>
                </div>
            </div>
        </div>
    )
}